import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ThreadAuthor } from "@teammood/timeline";
import { Emoji } from "../emojipicker/emoji.types";
import { Gif } from "../gifpicker/gif.types";
import { QuillEditorComponent, ContentChange } from "ngx-quill";
import { FormsModule } from "@angular/forms";
import { TmEmojipickerComponent } from "../emojipicker/emoji-picker.component";
import { TmGifPickerComponent } from "../gifpicker/gif-picker.component";
import Delta from "quill-delta";
import { takeWhile, tap } from "rxjs";

@Component({
    selector: "tm-rich-text-area",
    templateUrl: "./rich-text-area.component.html",
    styleUrls: ["./rich-text-area.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        QuillEditorComponent,
        FormsModule,
        TmEmojipickerComponent,
        TmGifPickerComponent
    ]
})
export class TmRichTextAreaComponent {

    @ViewChild(QuillEditorComponent, { static: true }) editor: QuillEditorComponent

    protected quillModelFormat: "object" | "json" | "html" | "text" = "object"

    @Input()
    content: Delta;

    @Input()
    placeholderText: string;

    @Input()
    customStyles: any;

    @Output()
    contentChange: EventEmitter<Delta> = new EventEmitter<Delta>();

    @Input()
    threadAuthors: ThreadAuthor[] = [];

    constructor() {
    }


    private toQuillMention(threadAuthor: ThreadAuthor): { threadAuthor: ThreadAuthor, value: string } {

        return {
            threadAuthor: threadAuthor,
            value: threadAuthor.name
        };
    }

    // whitelisting formats, eg disable bullet, strikethrough, fonts etc.
    protected quillFormats = [
        "bold",
        "italic",
        "link",
        "underline",
        "indent",
        "image",
        "mention",
        "tm-emoji",
        "tm-gif"
    ];

    protected quillConfig = {
        mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            renderItem: (item: { threadAuthor: ThreadAuthor, value: string }) => {
                return item.threadAuthor.name;
            },
            source: (searchTerm: string, renderList) => {
                const values = this.threadAuthors.map(this.toQuillMention);

                if (searchTerm.length === 0) {
                    renderList(values, searchTerm);
                } else {
                    const matches = [];
                    for (var i = 0; i < values.length; i++)
                        if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
                            matches.push(values[i]);
                    renderList(matches, searchTerm);
                }
            },
            customModules:[]
        }
    }

    protected onEditorCreated() {
        let loadingContent = true;
        this.editor.onContentChanged.pipe(
            tap(content =>{
                this.editor.quillEditor.setSelection(content.delta.length());
                loadingContent = false;
            }),
            takeWhile(() => loadingContent)
        ).subscribe();

        this.editor.quillEditor.setContents(this.content);
        this.editor.quillEditor.focus();
    }

    protected onContentChanged(change: ContentChange) {
        this.contentChange.emit(change.content);
    }

    protected addEmoji = (emoji: Emoji) => {
        const cursorPosition = this.editor.quillEditor.getSelection(true).index;
        this.editor.quillEditor.insertEmbed(cursorPosition, 'tm-emoji', emoji, "user");
        this.editor.quillEditor.setSelection(cursorPosition + 1);
    }

    protected addGif = (gif: Gif) => {
        const cursorPosition = this.editor.quillEditor.getSelection(true).index;
        //this.editor.quillEditor.insertEmbed(cursorPosition, 'image', gif.url, "user");
        this.editor.quillEditor.insertEmbed(cursorPosition, 'tm-gif', gif, "user");
        this.editor.quillEditor.insertText(cursorPosition + 1, ' ', "user");
        this.editor.quillEditor.setSelection(cursorPosition + 2);
    }

    protected clearContent() {
        this.editor.quillEditor.setContents([]);
    }

    showMentions(){
        this.editor.quillEditor.insertText(0, "@", 'user');
    }

}

